import { render, staticRenderFns } from "./driverScoreCard.vue?vue&type=template&id=515d72e6"
import script from "./driverScoreCard.vue?vue&type=script&lang=js"
export * from "./driverScoreCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports